import $ from 'jquery';
import { Tooltip } from 'bootstrap';
import App from './vendor/App';
import Controllers from './controllers/Controller';
import Header from './components/Header';
import Search from './components/Search';
import Select from './components/Select';
import AddToWishlistButton from './components/AddToWishlistButton';
import AddToCartButton from './components/AddToCartButton';
import MiniCart from './components/MiniCart';
import RemoveFromWishlistButton from './components/RemoveFromWishlistButton';
import Footer from './components/Footer';
import FlashMessage from './components/FlashMessage';

window.$ = window.jQuery = $;

new App({
    on: {
        ready: function () {
            new Header();
            new Search();
            new Select();
            new AddToWishlistButton();
            new AddToCartButton();
            new MiniCart();
            new RemoveFromWishlistButton();
            new Footer();
            new FlashMessage();

            const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
            const tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
                return new Tooltip(tooltipTriggerEl, {delay: { "show": 200, "hide": 100 }});
            });
        }
    },

    routes: {
        '/': Controllers.Home,
        '/productsForSale': Controllers.ProductsForSale,
        '/productUploadLanding': Controllers.ProductUploadLanding,
        '/productsHistory': Controllers.ProductHistory,
        '/checkProducts': Controllers.VerifyProduct,
        '/incompleteUploads': Controllers.NotFinishedProductsUpload,
        '/productUpload': Controllers.ProductUpload,
        '/negotiationsAsSeller': Controllers.Negotiation,
        '/negotiations': Controllers.Negotiation,
        '/contacts': Controllers.Contact,
        '/about': Controllers.About,
        '/login': Controllers.Login,
        '/registration': Controllers.Register,
        '/forgot': Controllers.PasswordReset,
        '/reset/{code}': Controllers.PasswordResetConfirmation,
        '/profile': Controllers.Profile,
        '/checkout': Controllers.Cart,
        '/step-two': Controllers.Cart,
        '/category': Controllers.Category,
        '/p{id}-{code}': Controllers.Product,
        '/p{id}-': Controllers.Product,
        '/p{id}': Controllers.Product,
        '/{lang}/p{id}-{code}': Controllers.Product,
        '/{lang}/p{id}-': Controllers.Product,
        '/{lang}/p{id}': Controllers.Product,
        '/c{id}-{code}': Controllers.Category,
        '/c{id}-': Controllers.Category,
        '/c{id}': Controllers.Category,
        '/{lang}/c{id}-{code}': Controllers.Category,
        '/{lang}/c{id}-': Controllers.Category,
        '/{lang}/c{id}': Controllers.Category,
        '/search': Controllers.Category,
        '/{lang}/search': Controllers.Category,
        '/{lang}': Controllers.Home,
        ////
        '/{lang}/informacje-dla-sprzedajacego': Controllers.Home,
        '/{lang}/informatsiya-dlya-prodavtsa': Controllers.Home,
        '/{lang}/seller-information': Controllers.Home,
    }
});
